import omit from 'lodash.omit';

// Global Types
import { ResetStateAction } from 'services/auth/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import { EntitiesState, EntitiesTypes } from './types';

// Local Constants
import {
    ENTITIES_UPDATE,
    ENTITY_UPDATE,
    ENTITY_REMOVE,
    ENTITIES_REMOVE,
    ENTITIES_UPDATES_PURGE,
    ENTITY_SET,
    ENTITIES_SET,
    ENTITIES_MERGE,
    ENTITIES_ERRORS_SET
} from './constants';

export const initialState: EntitiesState = {
    data: {},
    updates: {},
    deletes: [],
    errors: []
};

export default function (
    state: EntitiesState = initialState,
    action: EntitiesTypes | ResetStateAction
): EntitiesState {
    switch (action.type) {
        case ENTITIES_UPDATE:
            return {
                ...state,
                updates: {
                    ...state.updates,
                    ...action.payload
                }
            };
        case ENTITY_UPDATE:
            return {
                ...state,
                updates: {
                    ...state.updates,
                    [action.payload.uuid]: action.payload
                }
            };
        case ENTITY_REMOVE: {
            return {
                ...state,
                updates: omit(state.updates, action.payload)
            };
        }
        case ENTITIES_REMOVE: {
            const { payload } = action;

            const copy: EntitiesState = JSON.parse(JSON.stringify(state));

            payload.forEach((entityUuid) => {
                if (copy.data[entityUuid]) {
                    copy.deletes.push(entityUuid);
                }
                if (copy.updates[entityUuid]) {
                    delete copy.updates[entityUuid];
                }
            });

            return copy;
        }
        case ENTITIES_UPDATES_PURGE: {
            return {
                ...state,
                updates: {},
                deletes: [],
                errors: []
            };
        }
        case ENTITY_SET: {
            const { payload } = action;
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.uuid]: payload
                }
            };
        }
        case ENTITIES_SET: {
            const { payload } = action;
            return {
                ...state,
                data: payload
            };
        }
        case ENTITIES_MERGE: {
            const { payload } = action;
            const uuids = Object.keys(payload);
            return {
                ...state,
                data: {
                    ...state.data,
                    ...payload
                },
                updates: omit(state.updates, uuids),
                deletes: state.deletes.filter((uuid) => !uuids.includes(uuid))
            };
        }
        case ENTITIES_ERRORS_SET:
            return {
                ...state,
                errors: action.payload
            };
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
